import recallServices from '../../../../../../../services/supplier/supplier-recall'
import userServices from '../../../../../../../services/user'
import { EMAIL_STATUS } from '../../../../../../../misc/commons'
import store from '../../../../../../../store'
export default {
    name: 'NonVerifiedUserModal',
    data() {
        return {
            total: 0,
            delay: 700,
            clicks: 0,
            timer: null,
            items: [],
            searchQuery: {},
            organization_id: null,
            organizations: [],
            status: EMAIL_STATUS,
            createdEmailTime: null,
            createdEmail: null,
            editingEmailUserId: null,
            editingEmailValue: '',
            savingEmailUserId: null,
        }
    },
    computed: {
        header() {
            var arr = [
                {
                    label: 'Name',
                    name: 'full_name',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                },
                {
                    label: 'Email',
                    name: 'email',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                },
                {
                    label: 'Organization',
                    name: 'organization_name',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                },
                {
                    label: 'Title',
                    name: 'title',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                },
                {
                    label: 'Phone Number',
                    name: 'phone_number',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-30percent',
                },
                {
                    name: 'action',
                    row_text_alignment: 'text-right',
                    column_text_alignment: 'text-right',
                }
            ]

            if (this._isNotisphere) {
                return arr
            } else {
                if(store.state.userType =='SUPPLIER')
                {
                    return arr.filter(x => {
                        if (!['organization_name', 'organization_type','userSite'].includes(x.name)) {
                            return x
                        }
                    })
                }
                else{
                    return arr.filter(x => {
                        if (!['organization_name', 'organization_type'].includes(x.name)) {
                            return x
                        }
                    })
                }
            }
        },
        currentUserId() {
            return this.$store.state.user.id ? this.$store.state.user.id : -1
        }
    },
    methods: {
        forceRerenderInsert(organizationId) {
            this.organization_id = organizationId
            this.createdEmailTime = null
            this.createdEmail = null
            this.$refs.modal.show()
            this.$nextTick(() => {
                if (this.$refs.table) {
                    this.$refs.table.fetchDelay()
                }
            })
        },
        onCompleted(type) {
            if (type.type == 'UPDATE') {
                this._showToast('Updated successfully!')
            }
            if (type.type == 'INSERT') {
                this._showToast('Added successfully!')
            }
            this.createdEmailTime = type.emailTime
            this.createdEmail = type.emailId
            this.fetchData()
        },
        doubleClick(event) {
            this.clicks++
            if (this.clicks === 1) {
                var self = this
                this.timer = setTimeout(function() {
                    self.clicks = 0
                }, this.delay)
            } else {
                clearTimeout(this.timer)
                this.selectUser(event)
                this.clicks = 0
            }
        },
        startEmailEdit(item, e = null) {
            this.editingEmailUserId = item.id
            this.editingEmailValue = item.email || ''
            if (e) {
                e.stopPropagation()
            }
        },
        cancelEmailEdit(e = null) {
            this.editingEmailUserId = null
            this.editingEmailValue = ''
            if (e) {
                e.stopPropagation()
            }
        },
        async saveEmailEdit(item, e = null) {
            if (e) {
                e.stopPropagation()
            }

            const email = this.editingEmailValue ? this.editingEmailValue.trim() : ''
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!email || !emailPattern.test(email)) {
                this._showToast('Please enter a valid email address.', { variant: 'danger', title: 'Error' })
                return
            }

            this.savingEmailUserId = item.id
            try {
                const userResp = await userServices.getUser(item.id)
                if (userResp.error || !userResp.data || !userResp.data.d) {
                    return
                }

                const payload = {
                    ...userResp.data.d,
                    email,
                    NonVerified: true
                }
                const updateResp = await userServices.updateUser(payload)
                if (!updateResp.error) {
                    this._showToast('Email updated successfully!')
                    item.email = email
                    this.cancelEmailEdit()
                }
            } finally {
                this.savingEmailUserId = null
            }
        },
        selectUser(item, e = null) {
            this.$emit('onSelected', { email: item.email, name: item.full_name })
            this.$refs.modal.hide()
            if (e) {
                e.stopPropagation()
            }
        },
        fetchDelay() {
            this.$refs.table.fetchDelay()
        },
        fetchData() {
            recallServices.getNonVerifiedUsers({
                ...this.searchQuery,
                sortField: this.searchQuery.sort[0] ? this.searchQuery.sort[0].name : null,
                sortDirection: this.searchQuery.sort[0] ? this.searchQuery.sort[0].order : null,
                organizationId: this.organization_id
            }).then(resp => {
                if (!resp.error) {
                    this.items = resp.data.d.c
                    this.total = resp.data.d.t
                    for (let i = 0; i < this.items.length; i++) {
                        if (this.createdEmailTime != null) {
                            if (this.createdEmail == this.items[i].email) {
                                this.items[i].email_status_date = this.createdEmailTime
                            }
                        }
                        if (this.items[i].phone_number != null || this.items[i].phone_number != undefined) {
                            var x = this.items[i].phone_number.replace('+1', '').replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
                            this.items[i].phone_number = (x[1] ? x[1] + '-' : '') + x[2] + (x[3] ? '-' + x[3] : '')
                        }
                    }
                }
            })
        },
    }
}
